import { Navigate } from "react-router-dom";

export default function UCs() {
  return <Navigate to="/ambiental" replace />;
}